@let times = splitTimes();
@let stacked = isStacked();

<div [class]="{ 'request-times-display': true, 'request-times-display--stacked': stacked }">
  @for (time of times.visible; track $index) {
    <span class="request-times-display__entry">
      {{ stacked || $index === times.visible.length - 1 ? time : `${time},` }}

      @if ($last && times.truncated.length > 0) {
        <em tabindex="0" ftrTooltip [template]="truncatedTimes" alignment="auto" position="above" [showDash]="false">
          + {{ times.truncated.length }} timeframe{{ times.truncated.length === 1 ? '' : 's' }}
        </em>
        <ng-template #truncatedTimes>
          @for (time of times.truncated; track $index) {
            <div>{{ time }}</div>
          }
        </ng-template>
      }
    </span>
  }
</div>
